export default __webpack_public_path__ + "static/media/faq_arrow_down.10020a8c.svg";